var _ellipse, _path, _path2, _rect, _rect2, _path3, _path4, _rect3, _rect4, _path5, _path6, _path7, _path8, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWrong(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 258,
    height: 178,
    viewBox: "0 0 258 178",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.05,
    cx: 121.664,
    cy: 77.5227,
    rx: 121.664,
    ry: 77.5227,
    transform: "matrix(-0.915086 -0.403258 -0.403298 0.915069 273.614 67.9158)",
    fill: "#72A4FC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M203 99.0285C209.115 99.0285 214.071 94.0716 214.071 87.957C214.071 81.8425 209.115 76.8856 203 76.8856C196.885 76.8856 191.929 81.8425 191.929 87.957C191.929 94.0716 196.885 99.0285 203 99.0285Z",
    fill: "#CEC9C0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M198.571 61.3856C198.571 58.9398 200.554 56.957 203 56.957C205.446 56.957 207.429 58.9398 207.429 61.3856V64.0015C210.86 64.6318 214.04 65.9813 216.806 67.8879L218.657 66.0367C220.387 64.3073 223.191 64.3073 224.921 66.0367C226.65 67.7662 226.65 70.5702 224.921 72.2997L223.069 74.151C224.976 76.9172 226.325 80.097 226.955 83.5285H229.571C232.017 83.5285 234 85.5112 234 87.957C234 90.4029 232.017 92.3856 229.571 92.3856H226.955C226.325 95.8169 224.976 98.9966 223.07 101.763L224.921 103.614C226.651 105.343 226.651 108.147 224.921 109.877C223.191 111.606 220.387 111.606 218.658 109.877L216.807 108.026C214.041 109.933 210.86 111.282 207.429 111.913V114.528C207.429 116.974 205.446 118.957 203 118.957C200.554 118.957 198.571 116.974 198.571 114.528V111.913C195.14 111.282 191.96 109.933 189.194 108.026L187.343 109.877C185.614 111.607 182.81 111.607 181.08 109.877C179.35 108.148 179.35 105.344 181.08 103.614L182.931 101.764C181.024 98.9973 179.675 95.8173 179.045 92.3856H176.429C173.983 92.3856 172 90.4029 172 87.957C172 85.5112 173.983 83.5285 176.429 83.5285H179.045C179.675 80.0967 181.025 76.9167 182.931 74.1503L181.08 72.2996C179.351 70.5702 179.351 67.7662 181.08 66.0367C182.81 64.3072 185.614 64.3072 187.344 66.0367L189.194 67.8874C191.96 65.9811 195.14 64.6318 198.571 64.0015V61.3856ZM191.361 76.1103C191.291 76.1792 191.221 76.2488 191.153 76.3189C188.209 79.3156 186.393 83.4242 186.393 87.957C186.393 92.5079 188.223 96.6312 191.188 99.6308L191.326 99.7686C194.326 102.734 198.449 104.564 203 104.564C212.172 104.564 219.607 97.1289 219.607 87.957C219.607 78.7852 212.172 71.3499 203 71.3499C198.467 71.3499 194.358 73.166 191.361 76.1103Z",
    fill: "#CEC9C0"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 59.25,
    y: 47.9849,
    width: 74.1667,
    height: 115.056,
    rx: 3.75,
    fill: "white",
    stroke: "#EBEBEB",
    strokeWidth: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 69.6667,
    y: 58.4016,
    width: 53.3333,
    height: 53.3333,
    rx: 2,
    fill: "#C4D9FE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M123 119.846C123 119.294 122.552 118.846 122 118.846H70.6667C70.1144 118.846 69.6667 119.294 69.6667 119.846V126.735C69.6667 127.287 70.1144 127.735 70.6667 127.735H122C122.552 127.735 123 127.287 123 126.735V119.846Z",
    fill: "#E7E7E7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M123 135.846C123 135.294 122.552 134.846 122 134.846H70.6667C70.1144 134.846 69.6667 135.294 69.6667 135.846V151.624C69.6667 152.176 70.1144 152.624 70.6667 152.624H122C122.552 152.624 123 152.176 123 151.624V135.846Z",
    fill: "#72A4FC"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 103.694,
    y: 14.207,
    width: 99.0556,
    height: 131.056,
    rx: 3.75,
    fill: "white",
    stroke: "#EBEBEB",
    strokeWidth: 0.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 114.111,
    y: 24.6238,
    width: 78.2222,
    height: 53.3333,
    rx: 2,
    fill: "#C4D9FE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M187 86.0681C187 85.5158 186.552 85.0681 186 85.0681H115.111C114.559 85.0681 114.111 85.5158 114.111 86.0681V92.957C114.111 93.5093 114.559 93.957 115.111 93.957H186C186.552 93.957 187 93.5093 187 92.957V86.0681Z",
    fill: "#E7E7E7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M179.889 102.068C179.889 101.516 179.441 101.068 178.889 101.068H115.111C114.559 101.068 114.111 101.516 114.111 102.068V108.957C114.111 109.509 114.559 109.957 115.111 109.957H178.889C179.441 109.957 179.889 109.509 179.889 108.957V102.068Z",
    fill: "#E7E7E7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M192.333 118.068C192.333 117.516 191.886 117.068 191.333 117.068H115.111C114.559 117.068 114.111 117.516 114.111 118.068V133.846C114.111 134.398 114.559 134.846 115.111 134.846H191.333C191.886 134.846 192.333 134.398 192.333 133.846V118.068Z",
    fill: "#72A4FC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23 65.957L23 101.957C23 106.375 26.5817 109.957 31 109.957L59 109.957",
    stroke: "#B0B0B0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_16066_99292)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 34.957C4 31.6433 6.68629 28.957 10 28.957H38C41.3137 28.957 44 31.6433 44 34.957V62.957C44 64.6139 42.6569 65.957 41 65.957H7C5.34315 65.957 4 64.6139 4 62.957V34.957Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.125,
    y: 43.9146,
    width: 23.75,
    height: 7.87234,
    rx: 2,
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.125 45.9145C12.125 44.81 13.0204 43.9146 14.125 43.9146H18.375V51.7869H14.125C13.0204 51.7869 12.125 50.8915 12.125 49.7869V45.9145Z",
    fill: "#FFA9A9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_16066_99292",
    x: 0,
    y: 28.957,
    width: 48,
    height: 45,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.720833 0 0 0 0 0.720833 0 0 0 0 0.720833 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16066_99292"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_16066_99292",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrong);
export default __webpack_public_path__ + "static/media/wrong.51889aa3.svg";
export { ForwardRef as ReactComponent };